import React, { useEffect, useRef, ReactNode } from 'react';

interface ClickOutsideHandlerPropsType {
    children: ReactNode;
    onClickOutside: () => void;
}

export const ClickOutsideHandler = ({ children, onClickOutside }: ClickOutsideHandlerPropsType): JSX.Element => {
    const wrapperRef = useRef<HTMLDivElement | null>(null);

    useEffect(() => {
        const handleClickOutside = (event: MouseEvent): void => {
            if (wrapperRef.current === null) {
                return;
            }
            const target = event.target;

            if (target instanceof Node && wrapperRef.current.contains(target)) {
                return;
            }
            onClickOutside();
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [onClickOutside]);

    return <div ref={wrapperRef}>{children}</div>;
};
